import { startCase } from 'lodash';
import { Component, signal } from '@angular/core';

@Component({
  selector: 'cert-badge-collection-renderer',
  templateUrl: './badge-collection-renderer.component.html',
  styles: ``,
  standalone: false,
})
export class BadgeCollectionRendererComponent {
  params: any;
  items = signal<string[]>([]);

  agInit(params: any): void {
    this.params = params;
    const vals: any[] = Array.isArray(params.value) ? params.value : [];
    this.items.set(
      vals.map((x: any) => {
        if (params.mapCollectionToString && typeof params.mapCollectionToString === 'function') {
          const mapped = params.mapCollectionToString(x);
          if (mapped !== undefined && mapped !== null && String(mapped).trim() !== '') {
            return String(mapped);
          }
        }
        return typeof x === 'string' ? startCase(x) : String(x);
      }),
    );
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }
}
